function patch(update) {
  window.updateActionTrace?.(update);
}

function anchorFrom(source) {
  const el = source?.currentTarget || (source?.getBoundingClientRect ? source : null);
  if (!el || typeof el.getBoundingClientRect !== 'function') return null;
  const rect = el.getBoundingClientRect();
  const width = 300;
  const left = Math.min(Math.max(8, rect.left), Math.max(8, window.innerWidth - width - 8));
  const below = rect.bottom + 8;
  if (below + 240 > window.innerHeight && rect.top > 248) {
    return { left, bottom: window.innerHeight - rect.top + 8, placement: 'above' };
  }
  return { left, top: below, placement: 'below' };
}

export function startAction(title, defs, source) {
  const steps = defs.map((step, index) => ({
    id: step.id,
    icon: step.icon,
    label: step.label,
    detail: step.detail || '',
    state: index === 0 ? 'active' : 'pending',
  }));
  window.startActionTrace?.({ title, steps, pos: anchorFrom(source) });
  return {
    active(id, extra = {}) {
      patch({ step: { id, state: 'active', ...extra } });
    },
    done(id, extra = {}) {
      patch({ step: { id, state: 'done', ...extra } });
    },
    fail(id, extra = {}) {
      patch({ kind: 'error', step: { id, state: 'error', ...extra } });
      window.closeActionTrace?.(5000);
    },
    succeed(id, extra = {}) {
      patch({ kind: 'ok', step: { id, state: 'done', ...extra } });
      window.closeActionTrace?.(3500);
    },
  };
}

export const RESET_STEPS = [
  { id: 'sent', icon: 'mail', label: 'Anfrage gesendet' },
  { id: 'arrived', icon: 'inbox', label: 'Anfrage angekommen' },
  { id: 'processed', icon: 'status', label: 'Anfrage bearbeitet' },
  { id: 'answer', icon: 'events', label: 'Antwort' },
  { id: 'result', icon: 'ok', label: 'Ergebnis' },
];

export async function resetAlarmWithTrace(api, eventId, source) {
  const trace = startAction('Zurückstellen', RESET_STEPS, source);
  trace.done('sent');
  trace.active('arrived');

  let last = {};
  try {
    const res = await api.endpoints.events.reset({ id: eventId });
    last = res?.data || {};
  } catch (err) {
    last = err?.data || { status: 'error', message: err?.message };
  }

  if (last.rights === 'error') {
    trace.fail('arrived', { label: 'Keine Berechtigung' });
    return last;
  }

  trace.done('arrived');
  trace.done('processed');

  if (last.status === 'success') {
    if (last.historical) {
      trace.done('answer', { detail: 'Ruhige Zwischenzeit' });
      trace.succeed('result', { icon: 'confirmed', label: 'Alter Fall bestätigt' });
    } else {
      trace.done('answer', { detail: 'Gerät ruhig' });
      trace.succeed('result', { icon: 'ok', label: 'Alarm zurückgestellt' });
    }
    return last;
  }

  if (last.status === 'blocked') {
    trace.done('answer', { detail: 'Gerät bestätigt Alarm' });
    trace.fail('result', { icon: 'alarm', label: 'Alarm noch vorhanden' });
    return last;
  }

  trace.fail('answer', { label: last.message || 'Keine Antwort' });
  return last;
}

